import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiRegister, apiMe } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = not logged / checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("bp_token");
    if (!token) { setReady(true); return; }
    apiMe()
      .then((u) => setUser(u))
      .catch(() => localStorage.removeItem("bp_token"))
      .finally(() => setReady(true));
  }, []);

  const login = async (payload) => {
    const data = await apiLogin(payload);
    localStorage.setItem("bp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const data = await apiRegister(payload);
    localStorage.setItem("bp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
